export const roundTo2 = value => (value ? value.toFixed(2) : 0)

const generateTotalRowData = totalData => {
  const keys = [
    {
      label: 'Total',
    },
    {
      key: 'affiliateTotalInserts',
      value: totalData.affiliateTotalInserts,
    },
    {
      key: 'affiliateTotalPacks',
      value: totalData.affiliateTotalPacks,
    },
    {
      key: 'affiliateInsertCost',
      value: roundTo2(totalData.affiliateInsertCost),
    },
    {
      key: 'affiliateFreightCost',
      value: roundTo2(totalData.affiliateFreightCost),
    },
    {
      key: 'affiliatePromofyFee',
      value: roundTo2(totalData.affiliatePromofyFee),
    },
    {
      key: 'affiliatePrintingCost',
      value: roundTo2(totalData.affiliatePrintingCost),
    },
    {
      key: 'affiliateBonusBudget',
      value: roundTo2(totalData.affiliateBonusBudget),
    },
    {
      key: 'totalCost',
      value: roundTo2(totalData.totalCost),
    },
  ]

  return keys
}

const notCalculatedInColumnTotal = [
  'id',
  'key',
  'name',
  'tax',
  'state',
  'postalCode',
]

export const generateTotalRow = data => {
  const calculateColumnTotal = data.reduce((acc, item) => {
    const entries = Object.entries(item)

    entries.forEach(entry => {
      const key = entry[0]
      const value = entry[1]
      if (notCalculatedInColumnTotal.includes(key)) return acc
      if (acc[key]) {
        acc[key] += value
        return acc
      } else {
        acc[key] = value
        return acc
      }
    })
    return acc
  }, {})
  const totalRow = generateTotalRowData(calculateColumnTotal)
  return totalRow
}

export const calculateTotalCostDependingOfType = data => {
  const calculatedInTotalValues = [
    'affiliateInsertCost',
    'affiliateFreightCost',
    'affiliatePromofyFee',
    'affiliatePrintingCost',
    'affiliateBonusBudget',
  ]

  const affiliateMetricsWithTotal = data.map(item => {
    const entries = Object.entries(item)
    let total = 0
    entries.forEach(entry =>
      calculatedInTotalValues.includes(entry[0]) ? (total += entry[1]) : null,
    )

    const result = { ...item }

    result.totalCost = total
    result.subtotal = total - result.taxAmount

    return result
  })
  return affiliateMetricsWithTotal
}

export const isValueValid = value => {
  if (!value) {
    return true
  }
  return !/^\s*$/.test(value) && !isNaN(value)
}

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}
const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export const insertBeforeTotalCost = (headers, objectsToInsert) => {
  // Find the index of the object with key "totalCost"
  const totalCostIndex = headers.findIndex(item => item.key === 'totalCost')

  if (totalCostIndex === -1) {
    console.error('totalCost object not found in the array.')
    return headers
  }

  // Insert the objects at the found index
  headers.splice(totalCostIndex, 0, ...objectsToInsert)

  return headers
}
